import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import TableActions from "../../../components/Common/TableActions";
import Toggle from "../../../components/Common/Toggle";
import dataHandler from "../../../hooks/dataHandler";
import {
  DELETE_FAQ,
  GET_BASIC_SETTING,
  LIST_FAQS,
} from "../../../services/ApiCalls";
import { activeInactiveOptions } from "../../../utilities/const";
import moment from "moment";

const Faq = () => {
  const { t } = useTranslation();
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
    statusChangeHandler,
  } = dataHandler({
    api: LIST_FAQS,
    extraBody: { language: "English" },
    depenendencyArr: ["language"]
  });
  const [languages, setLanguages] = useState([]);

  const handleLanguageChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, language: value }));
  };


  const fetchLanguages = async () => {

    try {
      const res = await GET_BASIC_SETTING();

      if (res?.data?.status_code === 200) {
        setLanguages(res?.data?.data[0]?.languages ?? [])
      }

    } catch (err) {

    }

  }
  useEffect(() => {
    fetchLanguages();
  }, [])

  const column = [
    {
      head: t("faqManagement.columns.serialNumber"),
      accessor: "srNo",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    { head: t("faqManagement.columns.question"), accessor: "question" },
    {
      head: t("faqManagement.columns.status"),
      accessor: "",
      isComponent: true,
      component: (item, ind) => (
        <span
          className={`px-2 py-0 rounded ${item?.status === "Active"
            ? "bg-success text-white"
            : "bg-danger text-white"
            }`}
        >
          {item?.status === "Active" ? t("faqManagement.status.active") : t("faqManagement.status.inactive")}
        </span>
      ),
    },

    {
      head: t("faqManagement.columns.createdAt"),
      accessor: "createdAt",
      classNames: "fw-sbold",
      isComponent: true,
      component: (item) => (
        <>{moment(item.date_created_utc).format("MM-DD-YYYY , HH:MM")}</>
      ),
    },
    {
      head: t("faqManagement.columns.actions"),
      accessor: "",
      isComponent: true,
      //
      component: (item) => (
        <TableActions
          editUrl={`/faq/edit/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        confirmHandler={() =>
          deleteHandler(() => DELETE_FAQ({ _id: deleteModel.dumpId }))
        }
      />
      <section className="contentPage py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                {t("faqManagement.title")}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left d-flex gap-3 ">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Link
                        to={"/faq/add"}
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        {t("faqManagement.buttons.addNew")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout loader={loader} data={data} column={column} />
              <CustomPagination
                body={body}
                pageChangeHandler={paginationHandler}
                setBody={setBody}
                total={total}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Faq;
//
